import { render, staticRenderFns } from "./addTeam.vue?vue&type=template&id=5b1ce16d&scoped=true"
import script from "./addTeam.vue?vue&type=script&lang=js"
export * from "./addTeam.vue?vue&type=script&lang=js"
import style0 from "./addTeam.vue?vue&type=style&index=0&id=5b1ce16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ce16d",
  null
  
)

export default component.exports